import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import de from './locales/de.json';
import ar from './locales/ar.json';
import hi from './locales/hi.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import nl from './locales/nl.json';
import ru from './locales/ru.json';
import zh from './locales/zh.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'fr', name: 'French', nativeName: 'Fran\u00e7ais', flag: 'FR' },
  { code: 'en', name: 'English', nativeName: 'English', flag: 'GB' },
  { code: 'ar', name: 'Arabic', nativeName: '\u0627\u0644\u0639\u0631\u0628\u064a\u0629', flag: 'SA' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', flag: 'DE' },
  { code: 'es', name: 'Spanish', nativeName: 'Espa\u00f1ol', flag: 'ES' },
  { code: 'hi', name: 'Hindi', nativeName: '\u0939\u093f\u0928\u094d\u0926\u0940', flag: 'IN' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano', flag: 'IT' },
  { code: 'ja', name: 'Japanese', nativeName: '\u65e5\u672c\u8a9e', flag: 'JP' },
  { code: 'ko', name: 'Korean', nativeName: '\ud55c\uad6d\uc5b4', flag: 'KR' },
  { code: 'nl', name: 'Dutch', nativeName: 'Nederlands', flag: 'NL' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Portugu\u00eas', flag: 'PT' },
  { code: 'ru', name: 'Russian', nativeName: '\u0420\u0443\u0441\u0441\u043a\u0438\u0439', flag: 'RU' },
  { code: 'zh', name: 'Chinese', nativeName: '\u4e2d\u6587', flag: 'CN' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      pt: { translation: pt },
      de: { translation: de },
      ar: { translation: ar },
      hi: { translation: hi },
      it: { translation: it },
      ja: { translation: ja },
      ko: { translation: ko },
      nl: { translation: nl },
      ru: { translation: ru },
      zh: { translation: zh },
    },
    fallbackLng: 'fr',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'ahoow_language',
    },
  });

export const changeLanguage = (code) => {
  i18n.changeLanguage(code);
  localStorage.setItem('ahoow_language', code);
  document.documentElement.lang = code;
  document.documentElement.dir = code === 'ar' ? 'rtl' : 'ltr';
};

export default i18n;
